import moment from "moment";

export default {
  computed: {
    earlyBirdValid() {
      return moment.utc(this.event.datetime_eb).isAfter(moment.utc());
    },

    hasEarlyBird() {
      return this.event.datetime_eb;
    },

    vatable() {
      return this.event.show_vat && this.event.vat_exclusive;
    },

    earlyBirdInfo() {
      return (
        "Up To " +
        moment.utc(this.event.datetime_eb).format("DD/MM/YYYY") +
        " at " +
        moment.utc(this.event.datetime_eb).format("h:mm a")
      );
    },

    earlyBirdInfoExp() {
      return (
        "After " +
        moment.utc(this.event.datetime_eb).format("DD/MM/YYYY") +
        " at " +
        moment.utc(this.event.datetime_eb).format("h:mm a")
      );
    },

    topLineOverride() {
      return { borderTop: "4px solid " + this.event.phcolour };
    },

    showVatInTitle() {
      if (this.event.show_vat) {
        return "(" + (this.event.vat_exclusive ? "exc" : "inc") + " VAT)";
      } else {
        return "";
      }
    },
  },
};
